import type { AllocationMethod as ApiAllocationMethod, CostClass as ApiCostClass } from '@client/api';

import type { AllocationMethod, CostClassification } from './mock/portfolio-economy.mock';

/**
 * The API sends backend enum members; the frontend's values are camelCase because they double as
 * i18n keys (`classification.ownerCost`, `allocationMethod.evenSplit`).
 *
 * Both are typed as total `Record`s on purpose, the same arrangement as `ERP_SYSTEM_BY_API_VALUE`:
 * widening a backend enum becomes a **compile error** here rather than a blank cell in the grid.
 *
 * A `toLowerCase()` cannot stand in for these. It happens to work for the two cost classes and
 * breaks on two of the three methods — `PerSquareMetre` is British where the frontend key is
 * American, and `EquallyDistributed` and `evenSplit` are simply different words. That failure mode
 * is the worst available: the KLASSIFISERING column would look right while METODE fell through to
 * a missing i18n key on most rows.
 */
export const COST_CLASS_BY_API_VALUE: Record<ApiCostClass, CostClassification> = {
  CommonCost: 'commonCost',
  OwnerCost: 'ownerCost',
};

export const ALLOCATION_METHOD_BY_API_VALUE: Record<ApiAllocationMethod, AllocationMethod> = {
  PerSquareMetre: 'perSquareMeter',
  EquallyDistributed: 'evenSplit',
  NoiWeighted: 'noiWeighted',
};
